import { useLocation } from "react-router-dom";
import HeaderCarousel from "./components/HeaderCarousel";
import HeaderInfo from "./components/HeaderInfo";
import HeaderMenu from "./components/HeaderMenu";

// Danh sách url không có carousel
const urlWithoutCarousels = ["profile/detail"]

const Header = () => {
    let location = useLocation();
    return (
        <>
            <HeaderInfo />
            <HeaderMenu />
            {urlWithoutCarousels.some(subStr => location.pathname.includes(subStr)) ? null : <HeaderCarousel />}
        </>
    )
}

export default Header;